module.exports = __webpack_public_path__ + "static/media/csvExampleImg.442760aa.png";